import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Container } from "../../components/Container";
import { HeaderForm } from "./HeaderForm";

interface ContainerFormProps {
  dataTestId: string;
  titleLocale?: string;
  toggleName: string;
}

export const ContainerForm = ({
  titleLocale,
  dataTestId,
  children,
  toggleName,
}: PropsWithChildren<ContainerFormProps>) => {
  const { watch } = useFormContext();

  const isEnabled = watch(toggleName);
  useEffect(() => {
    const component = document.querySelector(`[data-testid='${dataTestId}']`);
    if (!isEnabled) {
      component && component.setAttribute("inert", "");
    } else {
      component && component.removeAttribute("inert");
    }
  }, [isEnabled, dataTestId]);

  return (
    <>
      {titleLocale && (
        <HeaderForm titleLocale={titleLocale} toggleName={toggleName} />
      )}
      <Container
        className="h-[calc(100%-3.823rem-3.972rem-4.784rem)] overflow-y-auto px-0 pb-8 pt-5"
        dataTestId={dataTestId}
      >
        {children}
      </Container>
    </>
  );
};
